import React, { Component } from "react";
import { Table, DatePicker, Button, Form, Select, Checkbox, message } from 'antd'
import moment from 'moment'
import { getStatisticsList, getCheckedTypeList } from '@/request/api'
import StaitEcharts from './staitEchart'
import { requestErrorLog } from "@/common/util";


const { Option } = Select;
// 开始日期-结束日期
const defaultSelectDate = {
  startDate: moment().startOf('day').subtract(29, 'days'),
  endDate: moment().endOf('day')
};

class ConsulationHospital extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataStats: "",
      commonColumn: [
        {
          title: '日期',
          dataIndex: 'Statistics_Date',
          key: 'Statistics_Date',
          render: (val) => (
            <span>
              {val && moment(val).format("YYYY-MM-DD")}
            </span>
          ),
        },
        {
          title: '当日接收数量',
          dataIndex: 'RECEIVE_COUNT',
          key: 'RECEIVE_COUNT',
        },
        {
          title: '当日会诊数量',
          dataIndex: 'COMPLETE_COUNT',
          key: 'COMPLETE_COUNT',
        },
        {
          title: '当日退回数量',
          dataIndex: 'EXIT_COUNT',
          key: 'EXIT_COUNT',
        },
        {
          title: '会诊百分比',
          dataIndex: 'CONSULTATION_PERCENTAGE',
          key: 'CONSULTATION_PERCENTAGE',
          render: (percentage) => (
            <span>{percentage || 0}%</span>
          ),
        },
      ],
      PageNo: 1,
      PageSize: 10,
      RowCount: 0,
      checkTypeList: [],
      checkedType: [],
      selectPriceDate: '',
      offsetDays: 31536000000 * 5
    }
  }

  componentDidMount() {
    this.getCheckedType()
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.setState({
      hospitalCode: userInfo.HOSPITAL_CODE
    }, () => {
      this.handleSubmit()
    })
  }

  handleSubmit = () => {
    this.props.form.validateFields((err, values) => {
      if (values.startTime > values.endTime) {
        message.error('开始时间不得大于结束时间')
        return;
      }
      let params = {
        Type: this.props.tabsKey === "会诊医院" ? "RegulatorsStatistics" : "ConsultationStatistics",
        HOSPITAL_CODE: this.state.hospitalCode,
        EXAM_CLASS: this.state.checkedType,
        Statistics_Type: this.props.tabsKey === "会诊医院" ? "会诊医院" : "",
        hospitalDateTime: [moment(values.startTime).format('YYYY-MM-DD'), moment(values.endTime).format('YYYY-MM-DD')],
        PageNo: this.state.PageNo,
        PageSize: this.state.PageSize
      }
      getStatisticsList(params).then((res) => {
        if (res && res.Status === 1) {
          this.setState({
            tableList: res.Result.data.list,
            dataStats: res.Result.Sum,
            RowCount: res.Result.data.rowcount,
          });
        }else {
					message.error('获取失败')
					requestErrorLog('', '数据统计-会诊病例量统计statisticalType === 会诊医院报错', 0,true)
				}
      })
    });
  }

  // 获取检查类型
  getCheckedType() {
    getCheckedTypeList().then(res => {
      if (res && res.Status === 1) {
        const checkedType = res.Result.dataList
        let checkTypeList = [];
        if (checkedType.length === 1 && !checkedType[0].Menu_Name) {
          checkTypeList = [];
        } else {
          checkedType.forEach(item => {
            checkTypeList.push({ label: item.CLASS_NAME, value: item.CLASS_CODE })
          })
        }
        this.setState({
          checkTypeList,
        })
      }else {
        message.error('获取失败')
        requestErrorLog('', '数据统计-会诊病例量统计获取检查类型列表报错', 0,true)
      }
    })
  }

  selectHospital = (value) => {
    this.setState({
      hospitalCode: value,
    })
  }

  // 只能选择今天跟今天之前的日期
  disabledDate = (current) => {
    if (this.state.selectPriceDate) {
      let selectV = moment(this.state.selectPriceDate, 'YYYY-MM-DD').valueOf()
      return current > moment(new Date(selectV + this.state.offsetDays).getTime()) ||
        current < moment(new Date(selectV - this.state.offsetDays).getTime()) ||
        current > moment().endOf('day')
    } else {
      return current > moment().endOf('day')
    }
  }
  changeRangePicker = (e) => {
    this.setState({
      selectPriceDate: ''
    })
  }
  calendarPriceRangeChange = (date) => {
    this.setState({
      selectPriceDate: date[0]
    })
  }
  //页码改变
  onChangePage = (page, pageSize) => {
    this.setState({
      PageNo: page,
    }, () => {
      this.handleSubmit()
    })
  }

  searchListFn = () => {
    this.setState({
      PageNo: 1,
      PageSize: 10
    }, () => {
      this.handleSubmit()
    })
  }

  handleCheckTypeValue = (checkedValues) => {
    this.setState({
      checkedType: checkedValues
    })
  }

  render() {
    const { form: { getFieldDecorator }, consultHospital } = this.props;
    const { tableList, dataStats, checkTypeList } = this.state
    return (
      <>
        <Form layout="inline" style={{ minWidth: "1260px" }}>
          <Form.Item label="日期选择" className="headerlable">
            {/* {getFieldDecorator("hospitalDateTime", {
              initialValue: [defaultSelectDate.startDate, defaultSelectDate.endDate],
              rules: [{ required: true, message: '日期不能为空！' }]
            })(
              <RangePicker
                disabledDate={this.disabledDate}
                onChange={this.changeRangePicker}
                onCalendarChange={this.calendarPriceRangeChange}
                allowClear
              />
            )} */}
            {getFieldDecorator('startTime', { initialValue: defaultSelectDate.startDate })(
              <DatePicker
                style={{ width: 145 }}
                allowClear={false}
                placeholder='开始日期'
                disabledDate={this.disabledDate}
              />)}
            <span style={{ display: 'inline-block', textAlign: 'center', width: 15 }}>-</span>
            <Form.Item style={{ width: 110 }}>
              {getFieldDecorator('endTime', { initialValue: defaultSelectDate.endDate })(
                <DatePicker
                  style={{ width: 145 }}
                  allowClear={false}
                  placeholder='结束日期'
                  disabledDate={this.disabledDate}
                />)}
            </Form.Item>
          </Form.Item>

          {this.props.tabsKey === "会诊医院" ?
            <Form.Item label="医院名称">
              {getFieldDecorator("hospitalCode", { rules: [{ required: true, message: '医院名称不能为空！' }], initialValue: this.state.hospitalCode })(
                <Select style={{ width: 260 }} onChange={this.selectHospital} allowClear>
                  {consultHospital && consultHospital.map((item) => {
                    return <Option value={item.HOSPITAL_CODE} key={item.HOSPITAL_CODE}>{item.HOSPITAL_NAME}</Option>
                  })}
                </Select>
              )}
            </Form.Item>
            : null
          }
          <Form.Item label="检查类型">
            {getFieldDecorator("EXAM_CLASS", { initialValue: [] })(
              <Checkbox.Group
                onChange={this.handleCheckTypeValue}
                options={checkTypeList}
              >
              </Checkbox.Group>
            )}
          </Form.Item>
          <Button style={{ marginLeft: '10px', marginTop: '4px' }} onClick={this.searchListFn}>查询</Button>
        </Form>
        <div className="wrap" style={{ minWidth: "1260px" }}>
          <Table
            style={{ width: "65%" }}
            columns={this.state.commonColumn}
            dataSource={tableList}
            bordered
            rowKey={record => record.Statistics_Date} // 需要修改为唯一的ID！
            pagination={{
              total: this.state.RowCount,
              current: this.state.PageNo,
              onChange: this.onChangePage,
            }}
          />
          <div className="wrap_right">
            <div className="site-card-border-less-wrapper">
              <p>总接收病例量：<span style={{ color: "#00A2E8" }}>{dataStats.TOTAL_RECEIVE}</span></p>
              <p>总会诊病例量：<span style={{ color: "#70CFA9" }}>{dataStats.TOTAL_CONSULTATION}</span></p>
              <p>总退回病例量：<span style={{ color: "#F36971" }}>{dataStats.TOTAL_EXIT}</span></p>
              <p>会诊百分比：{dataStats.CONSULTATION_PERCENTAGE === 'NaN' ? 0 : dataStats.CONSULTATION_PERCENTAGE} %</p>
            </div>
            <div style={{ width: "100%" }}>
              <StaitEcharts dataStats={dataStats} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Form.create()(ConsulationHospital);
